import { RISKIFIED_SESSION_ID_KEY } from 'constants/session';
import { uuidv4 } from 'utils/uuid';

/**
 * Gets or generates a Riskified session ID.
 * This ID is created on first user visit (before login) and persists in localStorage.
 * Max 100 characters as per Riskified requirements.
 */
export function getRiskifiedSessionId(): string {
    if (typeof window === 'undefined') {
        return '';
    }

    if (
        typeof localStorage === 'undefined' ||
        typeof localStorage.getItem !== 'function' ||
        typeof localStorage.setItem !== 'function'
    ) {
        return '';
    }

    let sessionId = localStorage.getItem(RISKIFIED_SESSION_ID_KEY);

    if (!sessionId) {
        sessionId = uuidv4();
        localStorage.setItem(RISKIFIED_SESSION_ID_KEY, sessionId);
    }

    return sessionId;
}
